<template>
    <div class="match-tag-container" :class="{ 'living-tag-container': type === '1' }">
        <img class="icon-play" :src="activeTag.icon" />
        <span class="tag-text">{{ activeTag.text }}</span>
    </div>
</template>

<script>
const iconLive = require("../assets/icons/icon-live.png")
const iconLiving = require("../assets/icons/icon-living.png")

const TAG_TYPES = new Map()
    .set("1", {
        text: "LANGSUNG HD",
        icon: iconLive,
    })
    .set("2", {
        text: "HIGHLIGHTS",
        icon: iconLiving,
    })

export default {
    props: {
        type: {
            type: String,
            default: ""
        },
    },

    computed: {
        activeTag() {
            return TAG_TYPES.get(this.type)
        },
    }
}
</script>

<style lang="less" scoped>
.match-tag-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    margin: 0 auto;
    padding: 0.125rem 0.25rem;
    font-weight: 500;
    font-size: 0.5rem;
    color: #16b13a;
    border-radius: 2px;
    border: 1px solid #16b13a;
    background-color: #ffffff;
    font-family: SF UI Display;

    .icon-play {
        margin-right: 0.1875rem;
        width: 0.5625rem;
        height: 0.5rem;
    }

    &.living-tag-container {
        color: #ffffff;
        background: #16b13a;
    }
}
</style>



// WEBPACK FOOTER //
// AppMatchTag.vue?6d660c06